import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { environment } from "@environments/environment";

import { Observable } from "rxjs";

export function headerInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const newReq = req.clone({
    headers: req.headers.set("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey),
  });
  return next(newReq);
}
